import React, { Component } from 'react';
import imgLock from "./lock.png";
import imgPimeRateLogo from "./primerates-logo.png";

class Transition extends Component {
    render() {
        return (
            <div className="box-wrp">
                <div className="boxb">
                    <h3>TRANSFERRING YOU</h3>
                    <p>to {this.props.lenderName}'s secure website</p>
                    <img src={imgLock} alt="" />
                </div>
                <div className="bg-images">
                    <img src={imgPimeRateLogo} alt="PrimeRates" />
                    <div className="arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12" />
                            <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </div>
                    <img src={this.props.lenderLogo} alt={this.props.lenderName} />
                </div>
                <script>
                    {window.location.href = this.props.redirectTo}
                </script>
            </div>)
    }
}

export default Transition;


// WEBPACK FOOTER //
// ./src/Transition.js